import { Box } from "@mui/material"
import ReactGA from "react-ga4"

interface AdvertisementProps {
  imageUrl: string
  hrefLink: string
  aspectRatio: "tall" | "short" | "square"
  additionalStyling?: object
  companyName: string
  advertisementId: number
}

const Advertisement = ({
  imageUrl,
  hrefLink,
  aspectRatio,
  additionalStyling,
  companyName,
  advertisementId,
}: AdvertisementProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        flexGrow: 1,
        minWidth: "100%",
        maxHeight: "48px",
        overflow: "hidden",
        ...additionalStyling,
      }}
    >
      <a
        href={hrefLink}
        onClick={() => {
          ReactGA.event({
            category: "Event",
            action: "Click advertisement url",
            label: companyName,
            value: advertisementId,
          })
        }}
        style={{
          display: "block",
          width: "100%",
          height: "100%",
          position: "relative",
        }}
      >
        <Box
          component="img"
          src={imageUrl}
          alt="Advertisement"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            borderTopRightRadius: "8px",
            borderTopLeftRadius: "8px",
            aspectRatio: aspectRatio,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "30%", // Adjust as needed
            borderTopRightRadius: "8px",
            borderTopLeftRadius: "8px",
            // background:
            //   "linear-gradient(to bottom, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0))",
          }}
        />
      </a>
    </Box>
  )
}

export default Advertisement
